import { Link, NavLink, useMatch } from "react-router";
import React, { useContext } from "react";

import { SettingsContext } from "../../../settingsContext";

interface Props {
  isSpa: boolean;
  href: string;
  isNavLink?: boolean;
  activeClassName?: string;
  className?: string;
  ariaLabel?: string;
  target?: string;
  uit?: string;
  onClick?: () => void;
  [propName: string]: any;
}

const BNLink: React.FC<Props> = (props) => {
  const { ariaLabel, children, className, href, isSpa, isNavLink, activeClassName, uit, onClick, ...restOfProps } =
    props;

  const { resolveUrl } = useContext(SettingsContext);
  const link = resolveUrl(href);
  const match = useMatch(link);

  const handleOnClick = (event) => {
    if (onClick) {
      event.preventDefault();
      onClick();
    }
  };

  const classNames =
    `${className || ""} ${typeof children !== "string" ? "not-text" : ""} ${
      isNavLink && match ? activeClassName : ""
    }`.trim() || undefined;

  if (!isSpa || onClick || props.target) {
    return (
      <a
        data-uit={uit}
        href={link}
        target={props.target}
        onClick={handleOnClick}
        className={classNames}
        aria-label={ariaLabel}
        {...restOfProps}
      >
        {children}
      </a>
    );
  }

  if (isNavLink) {
    return (
      <NavLink to={link} className={classNames} aria-label={ariaLabel} {...restOfProps}>
        {props.children}
      </NavLink>
    );
  } else {
    return (
      <Link to={link} className={classNames} aria-label={ariaLabel} {...restOfProps}>
        {children}
      </Link>
    );
  }
};

export default BNLink;
